import { Table } from '@mantine/core';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { SearchField } from '../../components/SearchField';
import { Title } from '../../components/Title';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { queryWithFilterPageAndSearch } from '../../util/api/queryWithFilterPageAndSearch';
import { formatToCurrency, formatToDateString } from '../../util/formatting';
import { undefinedCheck } from '../../util/undefinedCheck';
import type { MissedItemDto } from './types/MissedItemDto';
import { KeyedRow } from '../../components/KeyedRow';

export function MissedItems() {
	const { organisation } = useParams();
	const pagination = usePagination();
	const filter = useFilter();
	const [searchQuery, setSearchQuery] = useState('');

	const missedItemsCountQuery = queryWithFilterPageAndSearch<number>(
		`${organisation}/missed-items/count`,
		filter.value,
		pagination.value,
		searchQuery,
	);

	const missedItemsQuery = queryWithFilterPageAndSearch<MissedItemDto[]>(
		`${organisation}/missed-items/all`,
		filter.value,
		pagination.value,
		searchQuery,
	);

	return (
		<>
			<PageHeader title={'Missed Items'} filter={filter}>
				<SearchField
					placeholder={'Search products...'}
					onDelayComplete={(value) => setSearchQuery(value)}
					width={'20vw'}
				/>
			</PageHeader>
			<DataTable
				pagination={pagination}
				totalItems={missedItemsCountQuery.data?.value}
				isRowsLoading={missedItemsQuery.isLoading}
				isPaginationLoading={missedItemsCountQuery.isLoading}
				rows={pagination.value.pageSize}
				minHeight={'67vh'}
				maxHeight={'76vh'}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th w={'10vw'}><Title label={'SKUID'} /></Table.Th>
						<Table.Th w={'20vw'}><Title label={'Description'} /></Table.Th>
						<Table.Th><Title label={'Occurrences'} /></Table.Th>
						<Table.Th><Title label={'Total'} /></Table.Th>
						<Table.Th><Title label={'Branch'} /></Table.Th>
						<Table.Th w={'8vw'}><Title label={'Individual Price'} /></Table.Th>
						<Table.Th><Title label={'Status'} /></Table.Th>
						<Table.Th><Title label={'Date'} /></Table.Th>
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{missedItemsQuery.data?.value.map(
						(missedItem: MissedItemDto, index: number) => (
							// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
							<KeyedRow key={index}>
								<Table.Td>{undefinedCheck(missedItem.skuid)}</Table.Td>
								<Table.Td>{undefinedCheck(missedItem.description)}</Table.Td>
								<Table.Td>{missedItem.occurrences}</Table.Td>
								<Table.Td>{formatToCurrency(missedItem.total)}</Table.Td>
								<Table.Td>{undefinedCheck(missedItem.branchName)}</Table.Td>
								<Table.Td>
									{formatToCurrency(missedItem.individualPrice)}
								</Table.Td>
								<Table.Td>{undefinedCheck(missedItem.status)}</Table.Td>
								<Table.Td>{formatToDateString(missedItem.dateTime)}</Table.Td>
							</KeyedRow>
						),
					)}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
